import MaterialTable from '@material-table/core'
import { Typography } from '@mui/material'
import HeaderWithExportOptions from 'components/HeaderWithExportOptions'
import Spinner from 'components/Spinner'
import ViewMoreBtn from 'components/viewMoreBtn'
import React, { useContext, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import useSWR from 'swr'
import { CreditContext } from '../context'
// import EmptyCredit from './EmptyCredit'
import SingleCreditDetails from './SingleCreditDetails'
import Filter from 'components/Filter'
import { CSV } from 'components/CSV'
import TablePaginationDemo from 'components/Paginator'
import { useLocation } from 'react-router-dom'

export default withTranslation()(function CreditTable({ t }) {
    const [params, setParams] = useState()

    const { setDisplaySingleCredit, setSingleCreditsData } = useContext(CreditContext)
    const location = useLocation()
    useEffect(() => {
        setParams(location.search)
    }, [location])

    const { data: credits, isValidating } = useSWR(`transactions/type/credit${params}`)
    const head = ['Date', 'Action-By', 'Credit-Amount', 'Fee', 'Total', 'Status']
    const rest = credits?.data?.data?.map(y => [y?.date, y?.username, y?.gross_amount, y?.fee, y?.total, y?.status])
    const csvData = rest ? [head, ...rest] : []
    const pageDetails = credits?.data
    return (
        <div className='p-[24px] rounded-[16px] bg-white'>



            <HeaderWithExportOptions
                title={<div className='font-[700] font-[24px]'> {t('credit.credit')}</div>}
                exportOptions={[
                    {
                        name: t('settlements.table.filter'),
                        Content: () => <>
                            <Filter page='redemption-vault' />
                        </>,
                        click: 'filter'
                    },
                    {
                        name: t('transaction.table.export_csv'),
                        Content: () => <CSV fileName='credits.csv' csvData={csvData} />,
                        click: 'export'
                    }
                ]}
            />

            <SingleCreditDetails />

            {
                !isValidating ?
                    <MaterialTable

                        columns={[
                            { title: 'Date', field: 'date', render: (data) => <span>{data.date}</span> },
                            { title: 'Action By', field: 'username', render: (data) => <span>{data.username}</span> },
                            {
                                title: 'Credit amount (NGN)', field: 'formatted_gross_amount', headerStyle: { fontSize: '13px' }, cellStyle: { textAlign: 'left' }, render: (data) => {
                                    return <span>{data.transaction === 'credit' && data.gross_amount} {data.transaction === 'debit' && data.given_discount}</span>
                                }
                            },
                            { title: 'Type', field: 'transaction', render: (data) => <span>{data.transaction}</span> },
                            { title: 'Fee (NGN)', field: 'fee', render: (data) => <span>{data.fee}</span> },
                            { title: 'Total', field: 'total', render: (data) => <span>{data.total}</span> },
                            { title: 'Status', field: 'status', render: ({ status }) => <Typography sx={{ bgcolor: 'rgba(68, 196, 161, 0.12' }} className={`d-inline p-2 w-[fit-content] text-[${status === 'completed' ? '#44C4A1' : '#F2994A'}] border border-[${status === 'success' ? '#44C4A1' : '#F2994A'}] rounded-md`} >{status}</Typography> },
                        ]}
                        options={{
                            headerStyle: {
                                color: '#657585',
                                fontSize: '14px',
                                fontFamily: 'Helvetica Neue',
                                fontStyle: 'normal',
                                fontWeight: 700,
                                lineHeight: '150%',
                                textAlign: 'left'
                            },
                            search: '',
                            actionsColumnIndex: -1,
                            pageSize:pageDetails?.per_page

                        }}
                        localization={{
                            header: {
                                actions: ""
                            }
                            ,
                            body: {}
                        }}
                        data={!isValidating && credits?.data?.data}
                        title={''}
                        actions={[
                            {
                                icon: ViewMoreBtn,

                                tooltip: 'View full data',
                                onClick: (click, data) => { setDisplaySingleCredit(false); setSingleCreditsData(data) }

                            }
                        ]}

                        components={{
                            Action: ({ data }) => (
                                <>
                                    {/* <ViewMoreBtn click={() => { setDisplaySingleCredit(false); setSingleCreditsData(data) }} /> */}
                                </>
                            ),
                            Pagination: ({ data }) => (<TablePaginationDemo {...pageDetails} />)
                        }}
                    />
                    :
                    <Spinner data={credits?.data?.data} />
            }


        </div>
    )
})